import styled from "styled-components";

export const ActionsContainer = styled.div<{ noTopMargin?: boolean }>`
  display: flex;
  gap: 20px;
  ${({ noTopMargin }) => `margin: ${noTopMargin ? "0px" : "20px"} 0px 8px;`}
`;
